import React from 'react';
import Button from "../../../components/ui/button/button";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";
import {ReactComponent as PlusIcon} from "../../../images/icons/ui/plus-icon.svg";
import TextField from "../../../components/TextField/TextField";
import {ReactComponent as TrashIcon} from "../../../images/icons/ui/trash-icon.svg";
import API from "../../../components/api";
import {ReactComponent as EditIcon} from "../../../images/icons/ui/edit-icon.svg";
import {SERVER_URL} from "../../../config";
import ImageUploader from "../../../components/ui/imageUploader/imageUploader";
import ModalComponent from "../../../components/ui/modalComponent/modalComponent";
import {ReactComponent as OrderLeftIcon} from "../../../images/icons/ui/order-left.svg";
import TextEditor from "../../../components/ui/textEditor/textEditor";
import RadioSlider from "../../../components/ui/radioSlider/radioSlider";


class AdminPanelArticlesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],

            isArticleDeleteOpen: false,
            isArticleEditOpen: false,
            current: {},

            tabValues: [
                {name: 'Опубликовано', value: false},
                {name: 'Скрыто', value: true},
            ],
        }

        this.changeItem = (value, index, name) => {
            let {items} = this.state;

            items[index][name] = value

            this.setState({
                items: [...items]
            });
        }

        this.changeCurrent = (name, value) => {
            let {current} = this.state;

            current[value] = name

            this.setState({
                current: current
            });
        }

        this.addItem = () => {
            API.adminAddArticles()
                .then(data => {
                    this.props.addSnackbar("Статья успешно создана", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось создать статью", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.updateItems = () => {
            API.adminGetArticles()
                .then(data => this.setState({items: data}))
                .catch(error => {
                })
        }

        this.saveItems = (items) => {
            API.adminSaveFAQ(items)
                .then(data => {
                    this.props.addSnackbar("Вопросы успешно сохранены", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить вопросы", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.swapItem = (itemId, side) => {
            const {items} = this.state;

            const index = items.findIndex(c => c.id === itemId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= items.length) {
                return;
            }

            const current = items[index];
            items[index] = items[targetIndex];
            items[targetIndex] = current;

            this.setState({items: items})
        }

        this.editItem = (index, item) => {
            this.setState({
                isArticleEditOpen: true,
                current: item
            })
        };

        this.deleteItem = (index, item) => {
            this.setState({
                isArticleDeleteOpen: true,
                current: item
            })
        };

        this.deleteArticle = (itemId) => {
            API.adminDeleteArticles(itemId)
                .then(data => {
                    this.props.addSnackbar("Статья успешно удалена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось удалить статью", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.saveEditArticle = () => {
            API.adminEditArticle(this.state.current)
                .then(data => {
                    this.props.addSnackbar("Статья успешно изменена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                    this.setState({isArticleEditOpen: false})
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось изменить статью", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.changePublish = (value, index, name) => {
            let {items} = this.state;

            API.adminEditPublishArticle(items[index].id, value)
                .then(data => {
                    this.props.addSnackbar("Статья успешно изменена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось изменить статью", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }
    }

    componentDidMount() {
        this.updateItems()
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <div className='title'>
                    Статьи
                </div>
            </div>
            <div className='content'>
                <Button type='transparent' size='large' fullWidth
                        startIcon={<PlusIcon/>}
                        onClick={() => {
                            this.addItem()
                        }}>
                    Добавить
                </Button>
                <div className='items split'>
                    {
                        this.state.items.map((item, index) => {
                            return <div key={item.id} className='item split'>
                                <div className='content'>
                                    <div className='title'>{item.title}</div>
                                    <div className='subtitle'>{item.subtitle}</div>
                                </div>
                                <RadioSlider value={item.hidden}
                                             buttons={this.state.tabValues}
                                             setValue={(value) => this.changePublish(value, index, 'hidden')}/>
                                <div className='top'>
                                    <div className='button-group'>
                                        <div className='buttons'>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<EditIcon/>}
                                                    onClick={() => this.editItem(index, item)}>
                                                Редактировать статью
                                            </Button>
                                            <Button type='primary' size='medium' fullWidth
                                                    startIcon={<TrashIcon/>}
                                                    onClick={() => this.deleteItem(index, item)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
                <ModalComponent customClass="admin-panel-modal"
                                isOpen={this.state.isArticleDeleteOpen}
                                onClose={() => this.setState({isArticleDeleteOpen: false})}>
                    <div className='admin-panel-modal-entry'>
                        <div className='title'>
                            Вы действительно хотите удалить эту статью?
                        </div>
                        <div className='warning'>
                            Всё, что находится внутри неё, тоже будет удалено!
                        </div>
                        <div className='description'>
                            {this.state.current.title}
                        </div>
                        <div className='buttons row'>
                            <Button type='outlined' size='large' fullWidth onClick={() => {
                                this.deleteArticle(this.state.current.id)
                                this.setState({isArticleDeleteOpen: false})
                            }}>
                                Да, удалить
                            </Button>
                            <Button type='primary' size='large' fullWidth
                                    onClick={() => this.setState({isArticleDeleteOpen: false})}>
                                Отменить
                            </Button>
                        </div>
                    </div>
                </ModalComponent>
                <ModalComponent customClass="admin-panel-modal-full-page"
                                isOpen={this.state.isArticleEditOpen} isCloseButtonHidden={true}
                                onClose={() => this.setState({isArticleEditOpen: false})}>
                    <div className='admin-panel-modal-full-page-entry'>
                        <div className='admin-page-container'>
                            <div className='header'>
                                <Button customClass='icon-size-24' type='primary' size='medium' fullWidth
                                        startIcon={<OrderLeftIcon/>}
                                        onClick={() => this.setState({isArticleEditOpen: false})}/>
                                <div className='content'>
                                    <div className='title'>
                                        Редактор статьи
                                    </div>
                                </div>
                                <div className='controls'>
                                    <Button type='accent' size='medium' onClick={() => {
                                        this.saveEditArticle()
                                    }}>
                                        Сохранить
                                    </Button>
                                    <Button type='primary' size='medium'
                                            onClick={() => this.setState({isArticleEditOpen: false})}>
                                        Отменить
                                    </Button>
                                </div>
                            </div>
                            <div className='content'>
                                <TextField label='Заголовок' fullWidth
                                           value={this.state.current.title}
                                           onChange={(e) => this.changeCurrent(e.target.value, 'title')}/>
                                <TextField label='Краткий подзаголовок' fullWidth
                                           value={this.state.current.subtitle}
                                           onChange={(e) => this.changeCurrent(e.target.value, 'subtitle')}/>
                                <ImageUploader description='От 604 х 672, форматы jpeg, png' size='small'
                                               imageBase64={this.state.current.image_base64}
                                               url={this.state.current.image ? SERVER_URL + this.state.current.image : null}
                                               uploadHandler={(b64) => this.changeCurrent(b64, 'image_base64')}/>
                                <TextField label='Дата публикации, ДД.ММ.ГГГГ' fullWidth
                                           value={this.state.current.published_date}
                                           onChange={(e) => this.changeCurrent(e.target.value, 'published_date')}/>
                                <TextEditor initText={this.state.current.content ? this.state.current.content : null}
                                            onChange={(value) => this.changeCurrent(value, 'content')}/>
                            </div>
                        </div>
                    </div>
                </ModalComponent>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelArticlesPage);
